import { render, staticRenderFns } from "./FolieMitBild.vue?vue&type=template&id=2db5490d&scoped=true&"
import script from "./FolieMitBild.vue?vue&type=script&lang=js&"
export * from "./FolieMitBild.vue?vue&type=script&lang=js&"
import style0 from "./FolieMitBild.vue?vue&type=style&index=0&id=2db5490d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5490d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VImg})
